import React from 'react';
import { Download, Share2 } from 'lucide-react';
import Button from './Button';

/**
 * Компонент ToolResult - отображение результатов расчета инструмента
 * 
 * @param {ReactNode} children - Содержимое блока результатов
 * @param {string} title - Заголовок блока результатов
 * @param {function} onDownload - Обработчик для скачивания результатов
 * @param {function} onShare - Обработчик для отправки результатов
 * @param {string} className - Дополнительные классы CSS
 */
const ToolResult = ({ children, title = "Результат", onDownload, onShare, className = "" }) => {
  return (
    <div className={`bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm ${className}`}>
      <div className="flex justify-between items-center px-5 py-4 border-b border-gray-200 dark:border-gray-700">
        <h3 className="font-medium text-gray-900 dark:text-white">
          {title}
        </h3>
        
        <div className="flex items-center space-x-2">
          {onShare && (
            <button
              onClick={onShare}
              className="p-1.5 rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
              aria-label="Поделиться"
            >
              <Share2 className="h-4 w-4" />
            </button>
          )}
          
          {onDownload && (
            <button
              onClick={onDownload}
              className="p-1.5 rounded-md text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 hover:text-gray-700 dark:hover:text-gray-200 transition-colors"
              aria-label="Скачать"
            >
              <Download className="h-4 w-4" />
            </button>
          )}
        </div>
      </div>
      
      <div className="p-5">
        {children}
      </div>
    </div>
  );
};

/**
 * Компонент ResultItem - элемент результата с названием и значением
 * 
 * @param {string} label - Название параметра
 * @param {ReactNode} value - Значение параметра
 * @param {boolean} highlight - Выделить значение цветом
 * @param {string} color - Цвет выделения (indigo, emerald, orange)
 */
export const ResultItem = ({ label, value, highlight = false, color = "indigo" }) => {
  const colorClasses = {
    indigo: "text-indigo-600 dark:text-indigo-400",
    emerald: "text-emerald-600 dark:text-emerald-400",
    orange: "text-orange-600 dark:text-orange-400",
    red: "text-red-600 dark:text-red-400"
  };
  
  return (
    <div className="py-2 flex flex-col sm:flex-row sm:justify-between border-b border-gray-100 dark:border-gray-700 last:border-0">
      <span className="text-gray-600 dark:text-gray-400 mb-1 sm:mb-0">
        {label}
      </span>
      <span className={`font-medium text-gray-900 dark:text-white ${highlight ? colorClasses[color] : ''}`}>
        {value}
      </span>
    </div>
  );
};

export default ToolResult;